export function formatSales(sales) {
  return sales?.toLocaleString("en-US", {
    style: "currency",
    currency: "PHP",
  });
}
